import { render, staticRenderFns } from "./CustomerShowOrthoArch.vue?vue&type=template&id=7124b7ac"
import script from "./CustomerShowOrthoArch.vue?vue&type=script&lang=js"
export * from "./CustomerShowOrthoArch.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowOrthoArch.vue?vue&type=style&index=0&id=7124b7ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports